/**
 * Handle the behavior of the events filter
 */
let EventsFilter = {
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready
		document.addEventListener('DOMContentLoaded', EventsFilter._ready);
	},
	/**
	 * Fires when document's loaded & ready
	 */
	_ready: () => {
		// listen for custom events filter click
		document.addEventListener('calendarClear:click', EventsFilter._updateEventsFilter);
		document.addEventListener('calendarDay:click', EventsFilter._updateEventsFilter);
		
		// listen for click on pill links if they exist.
		const pillsLinks = document.querySelectorAll('.eventsfilter-wrapper-pills-pill-link');
		if (pillsLinks.length > 0) {
			pillsLinks.forEach((pillLink) => {
				pillLink.addEventListener('click', EventsFilter._pillLinkClickHandler);
			});
		}
	},
	/**
	 * Fires when a pill is clicked
	 * @param {object} e the event object
	 */
	_pillLinkClickHandler: (e) => {
		// prevent default clicking behavior
		e.preventDefault();

		// get the event_cat of the clicked pill
		const event_cat = parseInt(e.target.closest('.eventsfilter-wrapper-pills-pill').dataset.event_cat);

		// update the UI
		const pills = document.querySelectorAll('.eventsfilter-wrapper-pills-pill');

		if ( pills.length > 0 ) {
			pills.forEach( (pill) => {
				pill.classList.remove('active')
			} )
			e.target.closest('.eventsfilter-wrapper-pills-pill').classList.add('active');
		}

		// update the URL & history
		const url = new URL(window.location);

		if (0 === event_cat) {
			url.searchParams.delete('event_cat');
		}
		else {
			url.searchParams.set("event_cat", event_cat);
		}

		history.pushState({}, "", url);

		e.target.dispatchEvent(new CustomEvent('eventsfilter:click', {
			bubbles: true,
			detail: {
				event_cat: event_cat
			}
		}))

	},
	/**
	 * Refresh the events filter on calendar click.
	 */
	_updateEventsFilter: async () => {
		// map all current search params to the fetch url
		let currenturl = new URL(window.location);
		let fetchurl = new URL(ajaxurl);
		currenturl.searchParams.forEach((value, key) => {
			fetchurl.searchParams.append(key, value)
		});					
			
			// build the form data to send to the BE
		var formData = new FormData();
		formData.append('action', 'refresh_events_filter');

		// use async/await fetch to get the response
		const res = await fetch(fetchurl, {
			method: 'POST',
			body: formData,
		});
		const events_filter = await res.text();
		
		// render the response
		document.querySelector('.eventsfilter').innerHTML = events_filter;

		// re-attach the event listeners to the pills
		const pillsLinks = document.querySelectorAll('.eventsfilter-wrapper-pills-pill-link');
		if (pillsLinks.length > 0) {
			pillsLinks.forEach((pillLink) => {
				pillLink.addEventListener('click', EventsFilter._pillLinkClickHandler);
			});
		}
	}
}
// kick things off.
EventsFilter._init();

export default EventsFilter;
